import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectPage = (state: StoreSchema) =>
    state.products.paginatedProducts.currentPage
